
export const SHAMIR_SHARED_ROW_DEFAULTS = {
    C: 0,
    D: 'Soczewki Okularowe',
    E: 8,
    H: 'Shamir',
    J: 0,
    N: 'Korekcyjne',
    S: 0,
    T: 0,
    U: 0,
    V: 0,
    Z: 60,
    AA: 75,
    AM: '0,25',
};